/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import { useSelector } from "react-redux";
import { Openings } from "../../../common/svg/AllSvg";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../../../common/form/Error";

const JobOpening = () => {
    const { t } = useTranslation('common');
    const tenant: string = useSelector((state: any) => state.data.tenant);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>([])
    const [dataCount, setDataCount] = useState<number>(0)
    const [loading, setLoading] = useState<any>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const params = useParams();
    const navigate = useNavigate();
    const loaderData: any[] = window.innerWidth <= 500 ? [1, 2, 3] : [1, 2, 3, 4, 5, 6]

    const getData = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.jobCategory}`);

            if (res && res.status === 200) {
                if (window.innerWidth <= 550) {
                    setData(res?.data?.results?.slice(0, 3))
                } else {
                    setData(res?.data?.results?.slice(0, 6))
                }
                setDataCount(res?.data?.results?.length)
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching job category", error);
        }
    }

    useEffect(() => {
        !!lang && getData();
    }, [lang])

    const handleNavigate = () => {
        const protocol = window.location.protocol;
        const www = window.location.host?.includes("www.") ? true : false;
        const host = www ? window.location.host?.replace("www.", "") : window.location.host;
        let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
        const newUrl: any = tenant === url?.subdomain?.recruitment ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.recruitment}.${currentHost}`;
        if (params?.lang) {
            window.location.href = `${newUrl}/${params?.lang}`;
        } else {
            window.location.href = newUrl;
        }
    }

    const handleCategoryNavigate = (item: any) => {
        const protocol = window.location.protocol;
        const www = window.location.host?.includes("www.") ? true : false;
        const host = www ? window.location.host?.replace("www.", "") : window.location.host;
        let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
        const newUrl: any = tenant === url?.subdomain?.recruitment ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.recruitment}.${currentHost}`;
        if (params?.lang) {
            window.location.href = `${newUrl}/${params?.lang}/jobs/${item?.id}`;
        } else {
            window.location.href = `${newUrl}/jobs/${item?.id}`;
        }
    }

    return (
        <div className="pt-[30px] lg:pt-[70px] w-full container">
            <div className="min-h-[515px] w-full flex items-center msm:justify-between msm:flex-row flex-col gap-[30px] msm:pr-[30px] xlx:pr-[45px] relative">
                <div className="absolute top-0 left-0 right-0 bottom-0 items-center justify-center w-full h-full msm:flex hidden">
                    <div style={{ background: "linear-gradient(277deg, #FBFFF5 15.81%, #FCF1F1 94.45%)" }} className="w-full rounded-[10px] h-[400px] xlx:h-[429px] "></div>
                </div>

                <div style={{ background: "linear-gradient(277deg, #FBFFF5 15.81%, #FCF1F1 94.45%)" }} className="w-full rounded-[10px] p-[20px] sm:p-[35px] msm:pr-0 msm:pl-[65px] xlx:pl-[85px] msm:py-[65px] flex flex-col gap-[8px] relative z-[1] msm:!bg-none">
                    <h2 className="text-primaryText font-semibold max-w-[257px]">{t("corporate.explore_careers.title")}</h2>
                    <h5 className="text-blackDull font-medium max-w-[413px] pb-[6px] text-justify">{t("corporate.explore_careers.desc")}</h5>
                    <img src={require("../../../../assets/images/careers-category-bg.png")} alt="careers-category" className="w-fit" />
                </div>

                <div className="bg-white dark:bg-bgDark shadow-[0px_1.953px_3.906px_-1.953px_rgba(24,39,75,0.12),0px_3.906px_3.906px_-1.953px_rgba(24,39,75,0.08)] border border-[#E9E9E9] dark:border-[#5f5e5e] rounded-[20px] h-full p-[20px] msm:p-[25px] xlx:py-[33px] xlx:px-[34px] msm:w-auto w-full msm:min-w-[525px] xlx:min-w-[600px] flex flex-col gap-[15px] sm:gap-[20px] xlx:gap-[36px] relative z-[1]">
                    <h3 className="text-primaryText dark:text-white font-semibold">{t("corporate.explore_careers.category_title")}</h3>

                    <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 gap-[15px]">
                        {loading ? <>
                            {Array?.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                                <div className="animate-pulse w-full h-[97px] sm:h-[97px] xlx:h-[101px] bg-gray-200 rounded-[15px] xlx:rounded-[20px] dark:bg-gray-700" key={index}></div>
                            ))}
                        </> :
                            <>
                                {isError ? <div className="xsm:col-span-2 w-full *:!pb-0 mt-[-35px]"><Error /></div> : <>
                                    {Array?.isArray(data) && data?.map((item: any, index: number) => (
                                        <button className="rounded-[15px] xlx:rounded-[20px] border border-[#EEE] dark:border-[#5f5e5e] flex items-center gap-[12px] sm:gap-[15px] p-[10px] sm:p-[15px] xlx:p-[17px] focus:bg-[#aaaaaa0f] hover:bg-[#aaaaaa0f]" key={index} onClick={() => handleCategoryNavigate(item)}>
                                            <div style={{ backgroundColor: `${item?.bg_color}` }} className="min-w-[64px] h-[64px] flex items-center justify-center rounded-[8px]">
                                                <img src={item?.icon?.aws_file_url} alt="icon" className="w-[29px]" />
                                            </div>

                                            <div className="flex flex-col gap-[10px]">
                                                <h5 className="text-blackDull dark:text-textBlackDull font-semibold line-clamp-2 break-anywhere text-left">{item?.title}</h5>

                                                {/* <div className="bg-[#939393] bg-opacity-[0.1] rounded-[8px] text-xs font-semibold text-[#5B6880] dark:text-textBlackDark uppercase h-[29px] flex items-center justify-center whitespace-nowrap w-fit px-[12px] text-left">{item?.total_no_of_jobs} {t("corporate.explore_careers.openings")}</div> */}
                                            </div>
                                        </button>
                                    ))}
                                </>}
                            </>
                        }
                    </div>

                    <div className="w-full flex items-center justify-center">
                        {dataCount > data?.length && <button className="text-primaryText dark:text-white font-semibold flex items-center gap-[8px] uppercase focus:underline hover:underline text-sm" onClick={handleNavigate}>{t("corporate.explore_careers.view_all_opening")} <Openings className="fill-primaryText dark:fill-white" /></button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobOpening;